import React, { useEffect, useState } from "react";
import {
    Box,
    Paper,
    Typography,
    ListItem,
    ListItemButton,
    ListItemText,
    FormControl,
    InputLabel,
    Select,
    MenuItem
} from "@mui/material";
import { createProgram, updateProgram, getProgramCourses, requestPrograms, saveProgramCourses, deleteProgram } from "../../../remote/programRequests"
import ProgramForm from "./ProgramForm";
import LoadingCircle from "../../../components/LayoutComponents/LoadingCircle";
import theme from "../../../components/LayoutComponents/theme";

export default function Programs({ session, courses, companies, programs, setPrograms }) {
    const [selected, setSelected] = useState(null);
    const [programCourses, setProgramCourses] = useState([])
    const [selectedFacility, setSelectedFacility] = useState(0)
    const initialFormData = {

        additionalInformation: "",
        careerClusterId: null,
        creditHours: 0,
        degreeTypeId: null,
        deliveryFormatId: null,
        effectiveEndDate: null,
        effectiveStartDate: null,
        entityId: null,
        isActiveFlag: false,
        isFeatured: false,
        linkAdditionalInformation: "",
        programContact: "",
        programDescription: "",
        programEnrollmentType: "",
        programId: 0,
        programLengthMonths: 0,
        programLengthSemesters: 0,
        programLengthYears: 0,
        programName: "",
        programCode: "",
        programPrerequisites: "",
        programRequirements: ""
    };
    const [formData, setFormData] = useState(initialFormData)
    const [loading, setLoading] = useState(false)


    useEffect(() => {
        if (!session?.token) return;
        const loadCourses = async () => {
            if (selected?.programId) {
                try {
                    setLoading(true)
                    const response = await getProgramCourses(session?.token, selected?.programId);
                    setProgramCourses(response.data || []);
                } catch (error) {
                    console.error("Error fetching courses from program:", error);
                } finally {
                    setLoading(false)
                }
            } else {
                setProgramCourses([]);
            }
        };

        if (session?.token && selected?.programId !== 0) {
            loadCourses();
        }
    }, [session?.token, selected?.programId]);

    const handleSave = async () => {
        try {
            setLoading(true)
            if (formData?.programId === 0) {
                const res = await createProgram(session?.token, formData);

                if (res?.data?.programId) {
                    const resCourses = await saveProgramCourses(session?.token, res.data.programId, programCourses);
                    setProgramCourses(resCourses.data || []);
                }
                setPrograms((prev) => [res.data, ...prev]);
                setSelected(res.data);
                setFormData(res.data);
        } else {
            await updateProgram(session?.token, formData);
            await saveProgramCourses(session?.token, formData?.programId, programCourses);
            const res = await requestPrograms(session?.token)
            setPrograms(res.data || [])
        }
    } catch (err) {
        console.error("Error saving program.", err);
    } finally {
        setLoading(false)
    }
};

const handleDelete = async () => {
    try {
        setLoading(true)
        const res = await deleteProgram(session?.token, selected?.programId)
        setPrograms(res.data || []);
        setSelected(null);
        setFormData(initialFormData);
    } catch (err) {
        console.error("Error deleting program", err);
    } finally {
        setLoading(false)
    }
}

return (
    <>
        <Box sx={{ display: "flex", gap: 3, width: "100%", alignItems: "flex-start" }}>
            <Paper
                sx={{
                    width: "25%",
                    p: 2,
                    height: "60vh",
                    overflowY: "auto",
                }}
            >
                <Typography
                    variant="h6"
                    sx={{ mb: 2, color: theme.colors.purple, textAlign: "center" }}
                >
                    Programs
                </Typography>
                <FormControl fullWidth size="small" sx={{ mb: 2 }}>
                    <InputLabel>Filter by Education Facility</InputLabel>
                    <Select
                        value={selectedFacility}
                        label="Filter by Education Facility"
                        onChange={(e) => setSelectedFacility(e.target.value)}
                    >
                        <MenuItem value="">All</MenuItem>
                        {companies.map((fac) => (
                            <MenuItem key={fac.entityId} value={fac.entityId}>
                                {fac.entityName}
                            </MenuItem>
                        ))}
                    </Select>
                </FormControl>
                {programs?.length > 0 || !loading ?
                    programs?.filter(p => !selectedFacility || p.entityId === selectedFacility)
                        ?.sort((a, b) => a.programName.toLowerCase().localeCompare(b.programName.toLowerCase()))
                        ?.map((pro) => (
                            <ListItem key={pro.programId} disablePadding>
                                <ListItemButton
                                    selected={selected?.programId === pro.programId}
                                    onClick={() => {
                                        setSelected(pro);
                                        setFormData(pro);
                                    }}
                                >
                                    <ListItemText primary={pro?.programName} />
                                </ListItemButton>
                            </ListItem>
                        ))
                    : <Box sx={{ display: 'flex', alignContent: 'center', justifyContent: 'center' }}><LoadingCircle size={20} /></Box>
                }
            </Paper>
            <Box sx={{ flex: 1, minWidth: 600 }}>
                <ProgramForm
                    onSave={handleSave}
                    onDelete={handleDelete}
                    session={session}
                    courses={courses}
                    selectedCourses={programCourses}
                    setSelectedCourses={setProgramCourses}
                    formData={formData}
                    setFormData={setFormData}
                    loading={loading}
                />
            </Box>
        </Box>

    </>
)
}